import MobileSignUp from "./MobileSignUp";

export default MobileSignUp;
